import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type {Theme} from '@mui/material/styles';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NextLink from "next/link";
import {CmLinkableType} from "../../../../types";
import {CmLinkableWithChildren} from "../types/navigation";
import {commonStyles} from "../styles";
import {useNavigationTracking} from "tracking/hooks/useNavigationTracking";

export interface MobileMenuHeaderProps {
    navigationLevel: 0 | 1 | 2;
    activeCategory: CmLinkableType | null;
    activeSubcategory: CmLinkableType | null;
    onBackClick: () => void;
    onClose: () => void;
}

const MobileMenuHeader: React.FC<MobileMenuHeaderProps> = ({
                                                               navigationLevel,
                                                               activeCategory,
                                                               activeSubcategory,
                                                               onBackClick,
                                                               onClose
                                                           }) => {
    const {trackMainNavigation} = useNavigationTracking();
    if (navigationLevel === 0) {
        return null;
    }

    const currentItem = navigationLevel === 1 ? activeCategory : activeSubcategory;
    const currentItemWithChildren = currentItem as CmLinkableWithChildren | null;

    return (
        <Box sx={{display: "flex", flexDirection: "column"}}>
            <Box
                data-cypress="mobileMenuBackButton"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": commonStyles.hoverStyles,
                    height: "56px",
                    borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                    padding: "0 12px !important",
                }}
                onClick={onBackClick}
                aria-label="back to main menu"
            >
                <ChevronLeftIcon sx={{marginLeft: "-6px", color: "action.active"}}/>
                <Typography variant="navigationItem" sx={{
                    ml: 0.5,
                    fontWeight: undefined,
                    fontFamily: '"HelveticaNeueLTStd-Md", Helvetica, Arial, sans-serif'
                }}>
                    zurück
                </Typography>
            </Box>

            {/* Category title */}
            <Box
                data-cypress="mobileMenuCategoryTitle"
                sx={{
                    height: "56px",
                    display: "flex",
                    alignItems: "center",
                    borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
                    padding: "0 12px !important",
                }}
            >
                <NextLink
                    href={currentItemWithChildren?.selfUrl || "#"}
                    onClick={() => {
                        trackMainNavigation(navigationLevel, currentItemWithChildren?.teaserTitle, {
                            isMobile: true
                        });
                        onClose();
                    }}
                    style={{
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%'
                    }}
                    data-cypress="mobileMenuCategoryTitleLink"
                >
                    <Typography
                        sx={{
                            fontSize: '16px',
                            fontFamily: '"HelveticaNeueLTStd-Md", Helvetica, Arial, sans-serif',
                            color: (theme: Theme) => theme.palette.primary.main,
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {currentItemWithChildren?.teaserTitle}
                    </Typography>
                </NextLink>
            </Box>
        </Box>
    );
};

export default MobileMenuHeader;
